import { Route } from 'react-router-dom';

import AppLayout from 'layouts/AppLayout';

export default ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={props => <AppLayout><Component {...props} {...rest} /></AppLayout>} />
  );
}